/**
 * Enum representing the available user event repositories.
 */
export enum UserEventRepositories {
  CAVALIER = 'cavalier',
  DLS = 'dls',
  S3_EXTERNAL_BUCKET = 's3-external-bucket'
}
